import type { AnalyticsExternalSource } from '../analyticsModule/types'
import type { AnalyticsReportDefinition } from '../types'

export const getExternalSource = (
  dataSource?: AnalyticsReportDefinition['dataSource'],
): AnalyticsExternalSource | undefined => {
  if (dataSource === 'google_analytics') {
    return 'googleAnalytics'
  }
}
